/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Project_Import_StatusInputs */

const en_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importing Project | ${i?.status}`)
};

const fr_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importation du projet | ${i?.status}`)
};

const de_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projekt wird importiert | ${i?.status}`)
};

const it_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione del progetto | ${i?.status}`)
};

const ru_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проект импорта | ${i?.status}`)
};

const es_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importando Proyecto | ${i?.status}`)
};

const zh_cn2_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导入项目 | ${i?.status}`)
};

const ja_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポート | ${i?.status}`)
};

const hi_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात हो रहा है | ${i?.status}`)
};

const pt_pt2_project_import_status = /** @type {(inputs: Project_Import_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projeto de Importação | ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Importing Project \| {status}" |
*
* @param {Project_Import_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_status = /** @type {((inputs: Project_Import_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_import_status(inputs)
	if (locale === "de") return de_project_import_status(inputs)
	if (locale === "it") return it_project_import_status(inputs)
	if (locale === "ru") return ru_project_import_status(inputs)
	if (locale === "es") return es_project_import_status(inputs)
	if (locale === "zh-CN") return zh_cn2_project_import_status(inputs)
	if (locale === "ja") return ja_project_import_status(inputs)
	if (locale === "hi") return hi_project_import_status(inputs)
	if (locale === "pt-PT") return pt_pt2_project_import_status(inputs)
	return en_project_import_status(inputs)
});